import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Client for sge_infantil_core's routes/reportcard.js (mounted at /api/reportcard).
// Deliberately NOT reproducing the old sge_infantil_web "Pautas" screen's approach
// of hand-aggregating raw gradebook queries — that old screen never called this
// endpoint at all (grep found zero references), even though it already existed
// and does the aggregation server-side (computeReportCard in utils/reportCard.js).
export async function getReportCard({ levelId, classId, period, year, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/reportcard/${id}`, { params: { levelId, classId, period, year } });
}

export async function printReportCard({ levelId, classId, period, year, studentId, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/reportcard/${id}/pdf`, { params: { levelId, classId, period, year, studentId } });
}

// Cambridge boletim — all 3 trimestres side by side (ecrã Boletim).
export async function getReportCardYear({ levelId, classId, year, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/reportcard/${id}/year`, { params: { levelId, classId, year } });
}

export async function printReportCardYear({ levelId, classId, year, studentId, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/reportcard/${id}/year/pdf`, { params: { levelId, classId, year, studentId } });
}
